<div class="container discover-content">
  <section id="intro">
    <p>
      Welcome to Talespinner's Community Bookshelf! Discover stories crafted by fellow users, each a unique blend of human creativity and AI assistance. Explore these imaginative worlds, find your next favorite read, and get inspired. Happy reading!
    </p>
  </section>

  <section id="book-grid">
    <h2>Featured Books</h2>
    <div class="book-grid">
      <a *ngFor="let book of publicBooks" class="book-item" [routerLink]="['/book-project', book.id]" target="_blank">
        <div class="book-card">
          <div class="book-cover-wrapper">
            <div class="book-cover">
              <ng-container *ngIf="!coverLoading[book.id]; else loadingCover">
                <img [src]="bookCovers[book.id]" [alt]="book.title">
              </ng-container>
              <ng-template #loadingCover>
                <div class="cover-loading"></div>
              </ng-template>
            </div>
          </div>
          <div class="book-details">
            <h3 class="book-title">{{ book.title }}</h3>
            <p class="book-author">by {{ book.author }}</p>
            <div class="book-genre" *ngIf="book.genre">
              <span class="genre-tag">{{ book.genre }}</span>
            </div>
            <div class="book-metrics">
              <div class="metric">
                <i class="mdi mdi-eye"></i>
                <span>{{ book.metrics.uniqueViews }}</span>
              </div>
              <div class="metric">
                <i class="mdi mdi-heart"></i>
                <span>{{ book.metrics.totalLikes }}</span>
              </div>
            </div>
          </div>
          <div class="book-description-overlay">
            <div class="description-content">
              <h4>{{ book.title }}</h4>
              <p>{{ book.description }}</p>
            </div>
          </div>
        </div>
      </a>
    </div>
  </section>

  <nav *ngIf="totalItems > pageSize" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(currentPage - 1)" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="currentPage === page">
        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(currentPage + 1)" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</div>
